import React from "react";
import { connect } from "react-redux";
import { match, withRouter } from "react-router-dom";
import { Dispatch } from "redux";
import { CircularProgress, Grid, MenuItem, Select, Typography, useMediaQuery, useTheme } from "@material-ui/core";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { Data } from "../../framework/data";
import { AppState } from "../../store/reducer";
import { loadAnnualFinals } from "../../store/annual-finals/actions";
import { selectAnnualFinals } from "../../store/annual-finals/selectors";
import { AnnualFinals } from "../../store/annual-finals/models";
import AnnualFinalsTable from "./AnnualFinalsTable";
import { buildLevelView } from "./levelStandings";

interface AnnualFinalsPageProps {
    match: match<{ year: string }>;
    annualFinals: Data<AnnualFinals>;
    loadAnnualFinals: (year: string) => void;
}

const AnnualFinalsPage: React.FC<AnnualFinalsPageProps> = ({ match, annualFinals, loadAnnualFinals }) => {

    const theme = useTheme();
    // Nazwy grup są długie ("Kobiety: Średnio-zaawansowana+"), więc przyciski mieszczą się w rzędzie
    // dopiero na szerokich ekranach - niżej pokazujemy listę rozwijaną.
    const isSmall = useMediaQuery(theme.breakpoints.down('md'));

    const year = match.params.year;

    const [levelId, setLevelId] = React.useState<string>();

    React.useEffect(() => {
        loadAnnualFinals(year);
    }, [year]);

    switch (annualFinals.type) {
        case "LOADING": {
            return (<div style={{ width: '64px', height: '64px', marginLeft: 'auto', marginRight: 'auto' }}><CircularProgress /></div>);
        }
        case "FAILED": {
            return (<Typography>Klasyfikacja do finałów rocznych dla roku {year} jest niedostępna.</Typography>);
        }
        case "LOADED": {

            const levels = annualFinals.value.levels || [];

            if (levels.length === 0) {
                return (<Typography>Klasyfikacja do finałów rocznych dla roku {year} jest niedostępna.</Typography>);
            }

            // Punkty i kolejność przeliczamy po stronie klienta, bo w danej klasyfikacji liczą się tylko ligi
            // z tej kategorii (zawodniczka może grać jednocześnie w lidze kobiet i w lidze open).
            const level = buildLevelView(levels.find(l => l.id === levelId) || levels[0]);

            return (<>
                <Grid container spacing={2} direction="column">
                    <Grid item>
                        <Grid container alignItems="center" spacing={2}>
                            <Grid item>
                                <Typography variant="h6">Grupa:</Typography>
                            </Grid>
                            <Grid item>
                                {
                                    isSmall ? (
                                        <Select value={level.id} onChange={(evt: React.ChangeEvent<any>) => { setLevelId(evt.target.value) }} variant="outlined">
                                            {
                                                levels.map(l => (
                                                    <MenuItem key={l.id} value={l.id}>{l.name}</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    ) : (
                                            <ToggleButtonGroup
                                                value={level.id}
                                                exclusive
                                                style={{ flexWrap: 'wrap' }}
                                                onChange={(_, v) => { if (!!v) { setLevelId(v) } }}
                                            >
                                                {
                                                    levels.map(l => (
                                                        <ToggleButton key={l.id} value={l.id}>{l.name}</ToggleButton>
                                                    ))
                                                }
                                            </ToggleButtonGroup>
                                        )
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                    
                </Grid>
                {
                            level.standings && level.standings.length > 0 ? (<div style={{paddingTop: '16px'}}>
                                <AnnualFinalsTable seasons={annualFinals.value.seasons || []} level={level}></AnnualFinalsTable>
                            </div>) : (
                                    <Typography>W grupie {level.name} nie ma jeszcze żadnych wyników.</Typography>
                                )
                        }
            </>);
        }
        default: {
            return (<></>);
        }
    }
};

const mapStateToProps = (state: AppState) => {
    return {
        annualFinals: selectAnnualFinals(state)
    };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        loadAnnualFinals: (year: string) => dispatch(loadAnnualFinals({ year }))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AnnualFinalsPage));
